import { Injectable, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { SLLayer } from 'src/app/model/sl-layer';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { HexString } from 'src/app/types/@types/hex-string';
import { ViewStackComponent } from '../../view-stack/view-stack.component';

export type ColorType = 'xls' | 'wheel' | 'legacy';
export type PaletteLimits = {
  [key in ColorType]: Array<ColorType>;
}
export interface ColorPickerParams {
  handler: AnyHandler;
  color: HexString;
  type: ColorType;
  colorFor?: string;
  limits?: PaletteLimits;
}

@Injectable({
  providedIn: 'root'
})
export class ColorPickerDialogService {

  public request$: Subject<ColorPickerParams> = new Subject();
  constructor() { }


  Show(handler: AnyHandler, color: HexString, colorFor: string = '', type: ColorType = 'wheel', limits?: PaletteLimits) {
    this.request$.next({
      handler: (handler),
      color: (color),
      colorFor: (colorFor),
      type: (type)
    });
  }
}
